"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTooltipPositionByReferenceElement = exports.TooltipService = exports.Tooltip = void 0;
var tooltip_1 = require("./tooltip");
Object.defineProperty(exports, "Tooltip", { enumerable: true, get: function () { return __importDefault(tooltip_1).default; } });
var tooltip_service_1 = require("./tooltip-service");
Object.defineProperty(exports, "TooltipService", { enumerable: true, get: function () { return __importDefault(tooltip_service_1).default; } });
var getTooltipPositionByReferenceElement_1 = require("./utils/getTooltipPositionByReferenceElement");
Object.defineProperty(exports, "getTooltipPositionByReferenceElement", { enumerable: true, get: function () { return __importDefault(getTooltipPositionByReferenceElement_1).default; } });
//# sourceMappingURL=index.js.map